export default {
  name: "AppControl",
  props: {
    value: {},
    label: String,
    placeholder: String,
    error: String,
    placeholderPrefix: "Введите",
    theme: {
      type: String,
      default: "main",
      validator: value => ["main", "third"].indexOf(value) !== -1
    }
  },
  computed: {
    computedPlaceholder() {
      let result = this.placeholderPrefix ? this.placeholderPrefix + " " : "";

      if (this.placeholder) {
        result += this.placeholder;
      } else if (this.label) {
        result += this.label;
      }

      return result;
    },
    classObj() {
      return [`control_theme_${this.theme}`];
    },

    labelText() {
      return (this.label && this.label.length && `${this.label}:`) || null;
    }
  },

  render() {
    const { labelText, computedPlaceholder, error, classObj } = this;

    const errorBlock = <div class="control__error">{error}</div>;

    let content;
    if (this.$scopedSlots.default) {
      content = this.$scopedSlots.default({
        controlPlaceholder: computedPlaceholder
      });
    } else {
      content = this.$slots.default;
    }

    const bottomContent = errorBlock;

    return (
      <div class={["control", classObj]}>
        <label class="control__label">{labelText}&nbsp;</label>
        <div class="control__input-container">{content}</div>
        {bottomContent}
      </div>
    );
  }
};
